import { Container } from "react-bootstrap";
import Slider from "react-slick";

const ClientSlider = () => {
    const sliderSettings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };

    return (
        <>
            <section className="client-section">
                <Container>
                    <Slider {...sliderSettings}>
                        <div className="client-block p-5">
                            <img src="assets/images/clients/client1.png" alt=""  height="150px" />
                        </div>
                        <div className="client-block p-5">
                            <img src="assets/images/clients/client2.png" alt=""  height="150px" />
                        </div>
                        <div className="client-block p-5">
                            <img src="assets/images/clients/client3.png" alt="" height="150px" />
                        </div>
                        <div className="client-block p-5">
                            <img src="assets/images/clients/client4.webp" alt=""  height="150px" />
                        </div>
                    </Slider>
                </Container>
            </section>
        </>
    )
}
export default ClientSlider;